<button class="btn btn-outline-danger mx-1 btn-sm" (click)="openDeleteModel()" type="button">
  <span class="bi bi-trash"></span>
</button>
